import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';
import { Skeleton } from '@verclam/ui-kit';

const containerStyle = css`
	display: flex;
	flex-direction: column;
	gap: 1.25rem;
`;

const AiEnginesSkeleton: React.FC = () => {
	return (
		<div css={containerStyle}>
			<Skeleton height="8rem" borderRadius={theme.radii.xlarge} animation="wave" />
			<Skeleton height="16rem" borderRadius={theme.radii.xlarge} animation="wave" />
		</div>
	);
};

export default AiEnginesSkeleton;
